import React, { Component } from "react"

import { BASE, JARGON, KEY_VALUES, KIND, TAB } from "../../modules/constants"

import { withStyles } from "@mui/styles"
import Typography from "@mui/material/Typography"
import Box from "@mui/material/Box"

const styles = theme => ({
  '@keyframes blinker': {
    from: { opacity: 1, color: "white" },
    to: { opacity: 1, color: "black" },
  },
  box: {
    paddingTop: 16,
    paddingLeft: 20
  },
  messageHeading: {
    fontSize: 18,
    fontWeight: "bold",
  },
  messageText: {
    fontSize: 16,
    paddingTop: 12,

    animationName: '$blinker',
    animationDuration: '1.5s',
    animationTimingFunction: 'linear',
    animationIterationCount: 'infinite',
  },
})

class NoDataMessage extends Component {

  render() {
    // console.log('this.props:', this.props)
    const { classes, filter, kind, lseCompany, lsePerson, nsmSearchString, searchString, tabIndex, totalResults, zeroCommitteeNodes } = this.props
    var showNoDataMsg = true
    let dataType = ""
    let start = searchString === "" // searchString only used in Companies House tab
    let changeSearch = false
    let changeCheckboxes = false
    let changeSearchOrCheckboxes = false
    const searchChTab = tabIndex === TAB[BASE.SEARCH].INDEX
    // console.log('tabIndex:', tabIndex)
    // console.log('tabIndex !== TAB[BASE.SEARCH].INDEX && !lseCompany && !lsePerson:', tabIndex !== TAB[BASE.SEARCH].INDEX && !lseCompany && !lsePerson)
    // Set'changeCheckboxes' boolean depending on whether we should show `Try ticking some checkboxes` message
    // Eg. If there are no committee members, changing checkboxes will not help - hence zeroCommitteeNodes
    if (!searchChTab && !lseCompany && !lsePerson) {
      changeCheckboxes = totalResults !== 0
    }
    else
      // switch to handle search and checkboxes
      switch (kind) {
        // NB: Company and Person tabs do not have search
        // NB: KIND.NEXUS.COMPANY.DASHBOARD not relevant
        case KIND.NEXUS.COMPANY.BOARD:
          changeCheckboxes = true // There is always a board
          break

        case KIND.NEXUS.COMPANY.COMMITTEES:
          changeCheckboxes = zeroCommitteeNodes === false
          break

        case KIND.NEXUS.COMPANY.NEWS:
          changeCheckboxes = totalResults !== 0
          break

        case KIND.NEXUS.PERSON.ROLES:
          changeCheckboxes = true // Person always has some roles
          break

        case KIND.NEXUS.PERSON.COMMITTEES:
          changeCheckboxes = zeroCommitteeNodes === false
          break

        case KIND.NEXUS.PERSON.NEWS:
          changeCheckboxes = totalResults !== 0
          break

        case KIND.SEARCH.OFFICERS:
        case KIND.SEARCH.COMPANIES:
          changeSearch = totalResults === 0
          changeSearchOrCheckboxes = totalResults > 0
          break

        case KIND.LSE.NEWS:
          if (filter === "" && nsmSearchString === "")
            changeCheckboxes = true
          else
            changeSearchOrCheckboxes = true
          break

        // LSE COMPANIES, ROLES, PEOPLE, NEWS
        default:
          // NB: filter is the LSE tabs equivilent to 'searchString'
          changeSearchOrCheckboxes = filter !== ""
          changeCheckboxes = filter === ""
          break
      }

    // If it is not an lse person or company, radio button setting may still
    // indicate 'committess' etc, so we must set the dataType accordingly
    if (tabIndex === TAB[BASE.COMPANY].INDEX && !lseCompany)
      dataType = JARGON.PEOPLE
    else if (tabIndex === TAB[BASE.PERSON].INDEX && !lsePerson)
      dataType = JARGON.ROLES
    else {
      // switch to specify data type
      switch (kind) {
        case KIND.LSE.COMPANIES.OVERVIEW:
        case KIND.LSE.COMPANIES.BOARD:
        case KIND.LSE.COMPANIES.COMMITTEES:
        case KIND.LSE.COMPANIES.GOVERNANCE:
        case KIND.LSE.COMPANIES.DATES:
        case KIND.LSE.COMPANIES.ADVISERS:
          dataType = JARGON.COMPANIES
          break

        case KIND.LSE.ROLES.BOARD:
        case KIND.LSE.ROLES.COMMITTEES:
          dataType = JARGON.ROLES
          break

        case KIND.LSE.PEOPLE.BOARD:
        case KIND.LSE.PEOPLE.COMMITTEES:
          dataType = JARGON.PEOPLE
          break

        case KIND.LSE.NEWS:
          dataType = JARGON.RECENT_NEWS
          break

        case KIND.NEXUS.COMPANY.NEWS:
        case KIND.NEXUS.PERSON.NEWS:
          changeCheckboxes = totalResults > 0
          changeSearch = false
          dataType = JARGON.RECENT_NEWS
          break

        case KIND.NEXUS.COMPANY.BOARD:
          dataType = JARGON.PEOPLE
          break

        case KIND.NEXUS.PERSON.ROLES:
          dataType = JARGON.ROLES
          break

        case KIND.NEXUS.COMPANY.COMMITTEES:
          changeCheckboxes = zeroCommitteeNodes === false
          dataType = "committee members"
          break

        case KIND.NEXUS.PERSON.COMMITTEES:
          changeCheckboxes = zeroCommitteeNodes === false
          dataType = "committee roles"
          break

        case KIND.SEARCH.OFFICERS:
          dataType = JARGON.OFFICERS
          break

        case KIND.SEARCH.COMPANIES:
          dataType = JARGON.COMPANIES
          break

        default:
          dataType = "data"
          break
      }
    }

    const noDataTypesFound = (
      <Typography className={classes.messageHeading}>
        {`No ${dataType.toLowerCase()} found!`}
      </Typography>
    )

    const noCommitteeDataAvailable = (
      <Typography className={classes.messageHeading}>
        {`No committee data available`}
      </Typography>
    )

    return (
      <Box className={classes.box} >

        {!start && (changeSearch || changeCheckboxes || changeSearchOrCheckboxes) && noDataTypesFound}

        {/* Not the search tab and not lse person or company */}
        {!changeCheckboxes && !searchChTab && (!lseCompany || !lsePerson) && noDataTypesFound}

        {!changeCheckboxes && (lseCompany || lsePerson) && (kind === KIND.NEXUS.PERSON.NEWS || kind === KIND.NEXUS.COMPANY.NEWS) && noDataTypesFound}

        {!changeCheckboxes && (lseCompany || lsePerson) && (kind === KIND.NEXUS.PERSON.COMMITTEES || kind === KIND.NEXUS.COMPANY.COMMITTEES) && noCommitteeDataAvailable}

        {/* The companies house search string is has less than 4 characters */}
        {
          start && <Typography className={classes.messageHeading}>
            {`Enter ${KEY_VALUES.MIN_SEARCH_STR_LEN} characters or more and click the Companies or Officers button `}
          </Typography>
        }

        {/* There the search returned no items - irrelevant of checkboxes */}
        {
          !start && changeSearch && showNoDataMsg && <Typography className={classes.messageText}>
            {`Try changing your search`}
          </Typography>
        }

        {/* There are items but checkboxes are filtering them all out */}
        {
          changeCheckboxes && showNoDataMsg && <Typography className={classes.messageText}>
            {`Try ticking some checkboxes`}
          </Typography>
        }

        {/* There are items but checkboxes are filtering them all out */}
        {
          changeSearchOrCheckboxes && showNoDataMsg && <Typography className={classes.messageText}>
            {`Try ticking some checkboxes or changing your search`}
          </Typography>
        }

      </Box >
    )
  }
}

export default withStyles(styles)(NoDataMessage)